import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { CalendarProvider, CalendarService } from '../../services/calendar.service';
import { LearningRoadmapModel, LearningRoadmapService, RoadmapItemModel } from '../../services/learning-roadmap.service';

@Component({
  selector: 'tangram-learning-roadmap',
  templateUrl: './learning-roadmap.component.html',
  styleUrls: ['./learning-roadmap.component.scss']
})
export class LearningRoadmapComponent implements OnChanges {
  @Input() pathwayId: string = '';
  @Input() currentUser: any;
  @Input() completedVideoIds: string[] = [];

  roadmap: LearningRoadmapModel = { generatedAt: '', items: [], warnings: [] };
  isLoading = false;
  errorMessage = '';
  private readonly roadmapProvider: 'claude' = 'claude';
  calendarProvider: CalendarProvider = 'none';

  readonly calendarProviderOptions = [
    { value: 'none',   label: 'Calendar Disabled' },
    { value: 'google', label: 'Google Calendar' },
  ];

  constructor(
    private learningRoadmapService: LearningRoadmapService,
    private calendarService: CalendarService,
    private toaster: ToastrService
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.completedVideoIds && this.roadmap.items.length > 0) {
      this.applyProgressToRoadmap();
    }
  }

  generateRoadmap(): void {
    if (!this.pathwayId || !this.currentUser) {
      return;
    }
    this.isLoading = true;
    this.errorMessage = '';
    this.learningRoadmapService.generateRoadmap(this.pathwayId, this.roadmapProvider).subscribe(
      (roadmap) => {
        this.isLoading = false;
        this.roadmap = this.learningRoadmapService.recalculateAdaptiveRoadmap(roadmap);
        this.applyProgressToRoadmap();
      },
      () => {
        this.isLoading = false;
        this.errorMessage = 'Failed to generate roadmap. Please try again.';
      }
    );
  }

  regenerateRoadmap(): void {
    this.generateRoadmap();
  }

  onItemChange(updatedItem: RoadmapItemModel): void {
    this.roadmap = {
      ...this.roadmap,
      items: this.roadmap.items.map((item) => item.id === updatedItem.id ? updatedItem : item)
    };
  }

  onCalendarProviderChange(provider: CalendarProvider): void {
    this.calendarProvider = provider;
    this.calendarService.setProvider(provider);
  }

  syncToCalendar(): void {
    this.calendarService.syncRoadmap(this.roadmap.items).subscribe((res) => {
      if (res.success) {
        this.toaster.success(res.message, 'Calendar');
      } else {
        this.toaster.info(res.message, 'Calendar');
      }
    });
  }

  private applyProgressToRoadmap(): void {
    const updated = this.roadmap.items.map((item) => ({
      ...item,
      completed: this.completedVideoIds.includes(item.moduleId)
    }));
    this.roadmap = this.learningRoadmapService.recalculateAdaptiveRoadmap({
      ...this.roadmap,
      items: updated
    });
  }

}
